import IconBool from "components/IconBool";

const MT2GTable = ({item, items}) => {
    return (
        <>
            <td>
                <input
                    type="checkbox"
                    name="checkboxContainer"
                    key={item.id}
                    data-idx={item.id}
                    defaultChecked={items.current.chosen.includes(item.id)}
                    readOnly={true}
                />
            </td>
            <td>{item.name}</td>
            <td>{item.description}</td>
            <td>{item.model}</td>
            <td className="text-center">-</td>
            <td className="text-center">-</td>
            <td className="text-center">
                <IconBool value={item.has.has_pin} classAdd="me-2" />
                {item.values.pin === "-1" ? "-" : item.values.pin}
            </td>
            <td className="text-center">
                <IconBool value={item.has.has_apn_name} classAdd="me-2" />
                {item.values.apn_name === "" ? "-" : item.values.apn_name}
            </td>
            <td className="text-center">
                <IconBool value={item.has.has_apn_user} classAdd="me-2" />
                {item.values.apn_user === "" ? "-" : item.values.apn_user}
            </td>
            <td className="text-center">
                <IconBool value={item.has.has_apn_pass} classAdd="me-2" />
                {item.values.apn_pass === "" ? "-" : item.values.apn_pass}
            </td>
        </>
    );
};
export default MT2GTable;
